import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HubspotAuthService } from '../services/hubspot-auth-service';
import { AuthContext } from '../models/auth-context';
import { RedirectRouteStorageService } from '../../core/services/redirect-route-storage-service';

@Component({
  selector: 'app-hubspot-entry',
  template: `
    <div class="flex items-center justify-center min-h-screen">
      <div class="text-center">
        <h1 class="text-2xl font-bold mb-4">Connecting to HubSpot...</h1>
        <div
          class="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"
        ></div>
      </div>
    </div>
  `,
})
export class HubspotEntryComponent implements OnInit {
  private router = inject(Router);
  private hubspotAuthService = inject(HubspotAuthService);
  private redirectRouteStorageService = inject(RedirectRouteStorageService);
  private route = inject(ActivatedRoute);

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const context = params as AuthContext;

      if (!context.userId || !context.portalId) {
        console.error('Missing required parameters');
        return;
      }

      const redirect = this.hubspotAuthService.initiateAuth(context);
      if (redirect) {
        window.location.href = redirect;
      }

      const redirectRoute = this.redirectRouteStorageService.get();
      if (redirectRoute) {
        this.router.navigateByUrl(redirectRoute);
      } else {
        this.router.navigate(['/']);
      }
      this.redirectRouteStorageService.clear();
    });
  }
}
